import React, { useEffect, useRef } from "react";

/**
 * Inky custom cursor: a small dot + a mix-blend-difference ring.
 * Ring grows on hoverable elements (via [data-cursor="hover"] attr or a/button/select).
 */
const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const pos = useRef({ x: 0, y: 0 });
  const ring = useRef({ x: 0, y: 0 });
  const raf = useRef(0);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    if (window.matchMedia("(hover: none)").matches) return undefined;

    const onMove = (e) => {
      pos.current.x = e.clientX;
      pos.current.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0) translate3d(-50%,-50%,0)`;
      }
    };

    const loop = () => {
      ring.current.x += (pos.current.x - ring.current.x) * 0.16;
      ring.current.y += (pos.current.y - ring.current.y) * 0.16;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${ring.current.x}px, ${ring.current.y}px, 0) translate3d(-50%,-50%,0)`;
      }
      raf.current = requestAnimationFrame(loop);
    };

    const hoverables = "a, button, select, input, textarea, [data-cursor=hover]";
    const onOver = (e) => {
      if (e.target.closest && e.target.closest(hoverables)) {
        ringRef.current?.classList.add("hovered");
      }
    };
    const onOut = (e) => {
      if (e.target.closest && e.target.closest(hoverables)) {
        ringRef.current?.classList.remove("hovered");
      }
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);
    raf.current = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
    };
  }, []);

  return (
    <>
      <div ref={ringRef} className="cursor-ring" />
      <div ref={dotRef} className="cursor-dot" />
    </>
  );
};

export default CustomCursor;
